// TODO: should be placed in shared folder
import type { FormikErrors } from 'formik';
import type { ZodIssueBase } from 'zod';

type ErrorObject = {
    [key: string]: undefined | string[] | ErrorObject;
};

export const buildErrorObject = (errors: ZodIssueBase[]): FormikErrors<unknown> => {
    const result: ErrorObject = {};

    errors.forEach(({ message, path }) => {
        let acc: ErrorObject = result;

        path.forEach((cur, index) => {
            if (index === path.length - 1) {
                // We're at the last element in the path, assign the error message
                if (!acc[cur]) {
                    acc[cur] = message ? [message] : undefined;
                } else if (Array.isArray(acc[cur]) && message) {
                    (acc[cur] as string[]).push(message);
                } else {
                    acc[cur] = [acc[cur], message] as string[];
                }
            } else {
                // If the key doesn't exist yet, create an empty object
                if (!acc[cur]) {
                    acc[cur] = {};
                }
                acc = acc[cur] as ErrorObject; // Navigate deeper into the object
            }
        });
    });

    return result;
};
